import {
  StyleSheet
} from "@react-pdf/renderer";

export const styles = StyleSheet.create({
    page: { paddingHorizontal: 48, paddingVertical: 80, fontFamily: "Calibri", },
    header: { width: "100", position: "absolute", top: 26, right: 48,  },
    name: { fontSize: 16, fontWeight: "bold", paddingTop: 10, },
    nameFirstLetter: { fontSize: 20, fontWeight: "bold",  },
    position:{ fontSize: 9.5, fontWeight: "bold",  },
    positionFirstLetter: { fontSize: 12, fontWeight: "bold",  },
    title: { fontSize: 11, fontWeight: "bold",  },
    titleFirstLetter: { fontSize: 14, fontWeight: "bold",  },
    section: { marginBottom: 30, paddingHorizontal: 24, },
    text: { fontSize: 12, lineHeight: 1, marginBottom: 2, textAlign: "justify" },
    text13: { fontSize: 13, lineHeight: 1, marginBottom: 2, textAlign: "justify" },
    edDegree: {fontSize: 13, fontWeight: "bold", width: "60", },
    line: {width: "100%", height: 0.5, marginBottom: 12, backgroundColor: "black",},
    bulletList: {paddingLeft: 10},
    projectDetailRow: { marginBottom: 6 },
    projectDetailLabel: { fontWeight: "bold" },
    responsibilitiesLabelRow: { paddingTop: 4, marginBottom: 6 },
  });